import { cleanDeviceName } from '@/utils/device-name';

export interface DeviceIdentity {
  /** Name set in the system settings ("Galaxy Tab S9 FE"); generic on recent iOS ("iPad"). */
  name?: string;
  manufacturer: string;
  model: string;
}

/**
 * Label of the device in the account's device list (VOL-14). The system name is
 * what the coach recognises; without it, maker and model ("Samsung SM-X710").
 */
export function deviceLabel(identity: DeviceIdentity): string | null {
  const name = cleanDeviceName(identity.name);
  if (name) return name;

  const manufacturer = cleanDeviceName(identity.manufacturer) ?? '';
  const model = cleanDeviceName(identity.model);
  if (!model) return null;
  const maker = manufacturer ? manufacturer.charAt(0).toUpperCase() + manufacturer.slice(1) : '';
  const label = !maker || model.toLowerCase().startsWith(maker.toLowerCase()) ? model : `${maker} ${model}`;
  return cleanDeviceName(label) ?? null;
}
